import React from 'react'
import { Card } from 'react-bootstrap'

function CardCustom(props) {
  const {
    children,
    className = '',
    minHeight = '88vh',
    style,
    ...other
  } = props
  return (
    <Card
      border="0"
      {...other}
      className={`rounded-3  shadow-sm ${className}`}
      style={{ minHeight, ...style }}
    >
      {children}
    </Card>
  )
}

export default CardCustom
